import { httpGet, httpPost } from "utils/httpRequest";

export const getProducts = async () => {
  // Prefer DB-backed product gates (admin endpoint).
  try {
    const resp = await httpPost("admin/productGate/list", {});
    const payload = resp?.data;
    if (payload?.rtnCode === 200 || payload?.rtnCode === 0) {
      const arr = payload?.data;
      if (Array.isArray(arr)) {
        // Normalize shape for older CMS components that still expect `programId`.
        // `programId` here is actually product_gate.id (aka productGateId).
        return arr
          .filter((p) => p && typeof p === "object")
          // Pickers should only offer active gates; inactive ones remain editable on Product Gates.
          .filter((p) => p.active !== false)
          .map((p) => {
            const id = Number(p?.productGateId ?? p?.id ?? p?.programId ?? 0);
            return {
              ...p,
              id: Number.isFinite(Number(p?.id)) ? Number(p.id) : id,
              productGateId: id,
              programId: id,
              code: String(p?.code || "").trim(),
              name: String(p?.name || p?.code || "").trim(),
            };
          })
          .filter((p) => Number.isFinite(p.programId) && p.programId > 0);
      }
    }
  } catch {}

  // Fallback: backend client/products (legacy WTGB or DB-backed, depending on deployment).
  const resp = await httpGet("client/products", {
    client_type: 2,
    client_version: "1.0.0",
  });
  // unwrap BaseResult envelope
  const arr = resp?.data?.data ?? [];
  if (!Array.isArray(arr)) return [];
  // client/products returns { productGateId, code, name, ... }
  // Normalize for older CMS components.
  return arr
    .filter((p) => p && typeof p === "object")
    .map((p) => {
      const id = Number(p?.productGateId ?? p?.id ?? p?.programId ?? 0);
      return {
        ...p,
        productGateId: id,
        programId: id,
        code: String(p?.code || "").trim(),
        name: String(p?.name || p?.code || "").trim(),
      };
    })
    .filter((p) => Number.isFinite(p.programId) && p.programId > 0);
};


